<template>
    <div>
        <v-card class="mb-2">
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REGISTRO DE PRE-EMBARQUES</v-card-title>
                    </v-col>
                    <v-col cols="1"  @click="abrirAyudas" >
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>

            </v-card-text>

            <v-row class="ml-1 mr-1">
                <v-col>
                    <v-select
                        :items="bodegas"
                        item-text="nombre"
                        item-value="id"
                        v-model="bodega_origen"
                        label="Seleccione Bodega Origen"
                        @change="cargarLotes"
                        class="pt-2"
                    ></v-select>
                    <v-alert v-if="!$v.bodega_origen.required" v-model="validar" type="error" outlined>Debe Seleccionar Bodega</v-alert>
                </v-col>
                <v-col>
                    <v-text-field 
                        v-model="nombre" 
                        label="Nombre identificativo" 
                        placeholder="Nombre del preembarque">
                    </v-text-field>
                    <v-alert v-if="!$v.nombre.required" v-model="validar" type="error" outlined>Falta Nombre del Preembarque</v-alert>
                    <v-alert v-if="!$v.nombre.minLength" v-model="validar" type="error" outlined>Debe tener al menos 6 letras</v-alert>
                </v-col>
                <v-col>
                    <date-picker 
                        v-model="fecha" 
                        placeholder ="Fecha despacho"
                        label ="Fecha Despacho" 
                        format="DD-MM-YYYY" 
                        :default-value="fecha" 
                        valueType="YYYY-MM-DD"
                        class="pt-2"
                    ></date-picker>
                    <v-alert v-if="!$v.fecha.required" v-model="validar" type="error" outlined>Indique una fecha</v-alert>
                </v-col>
                <v-col>
                    <v-select
                        :items="clientes"
                        item-text="nombre"
                        item-value="id"
                        v-model="cliente"
                        label="Cliente destino"
                        class="pt-2"
                    ></v-select>
                    <v-alert v-if="!$v.cliente.required" v-model="validar" type="error" outlined>Falta Cliente de destino</v-alert>
                </v-col>
                <v-col>
                    <v-text-field 
                        v-model="observaciones" 
                        label="Observaciones / Comentarios" 
                        placeholder="Observaciones">
                    </v-text-field>
                </v-col>
            </v-row>
        </v-card>
        <v-row class="ml-1 mr-1" v-if="alert">
            <v-col>
                <v-alert
                    dense
                    text
                    type="success"
                >
                Preembarque Generado Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                </v-alert>
            </v-col>
        </v-row>

        <v-spacer></v-spacer>

        <v-card class="mt-3">
            <v-row>
                <v-col>
                    <v-card>
                        <v-row class="ml-1 mr-1">
                                <v-col>
                                    <v-autocomplete
                                        v-model="lote"
                                        :items="lotes"
                                        item-text="nombre_lote"
                                        item-value="id"
                                        label="Seleccione Lote"
                                        color="blue darken-3"
                                        return-object
                                        @change="cargarJumbosLote($event)"
                                        dense
                                    ></v-autocomplete>
                                </v-col>
                                <v-col class="text-center">
                                    Bodega Origen
                                </v-col>
                                <v-col>
                                    <v-btn class="float-right" small dark color="#1565C0" @click="agregar">
                                        <!-- <span>Asignar</span> -->
                                        <v-icon>keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        <v-divider></v-divider>
                        <v-card-text class="bloque-maxis">
                            <v-row>
                                <v-col>
                                    <v-checkbox
                                        v-model="checkbox_select"
                                        label="Todos"
                                        color="#0288D1"
                                        class="float-right"
                                        hide-details
                                        @change="seleccionarTodos"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col v-for="f, idx in fecha_jumbos" :key="idx" cols="12" class="py-4"> 
                                    <p class="titulo-fecha">{{`FECHA ELABORACION: ${ formatDate(f)  }`}}</p>
                                    <v-row> 
                                        <v-col v-for="j in jumbos_ordenados.filter(j => j.fecha_elab == f)" :key="j.id" class="my-0 py-0">
                                            <v-switch v-model="j.switch" :label="`${j.nro_jumbo}`" v-if="!j.preembarques_id"></v-switch>
                                            <v-badge  v-if="j.preembarques_id" color="error" :content="`${j.nro_jumbo}`" inline :title="`en preembarque: ${j.preembarques_id}`"></v-badge>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col>
                    <v-card>
                        <v-row class="ml-1 mr-1">
                            <v-col>
                                <v-btn small dark color="#1565C0" @click="quitar">
                                    <v-icon>keyboard_arrow_left</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col><p>Reservar para Preembarque</p></v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-card-text class="bloque-maxis">
                            <v-row v-for="ls in lotesSalientes" :key="ls.id">
                                <v-col>
                                    <p class="titulo-fecha">{{`LOTE: ${ls.nombre_lote}`}}</p>
                                    <v-row>
                                        <v-col v-for="j in ls.jumbos" :key="j.id" class="ma-0 pa-0">
                                            <v-switch :title="formatDate(j.fecha_elab)" v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <h3>Total Kilos: {{ kilos }}</h3>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-alert v-if="!$v.lotesSalientes.required" v-model="validar" type="error" outlined>
                        Debe indicar maxisacos que se reservarán para este preembarque.
                        Para ello: seleccione un lote, seleccione maxisacos en ese lote y páselo a "Reservar para Preembarque" con la flecha >
                    </v-alert>
                    
                </v-col>
            </v-row>
        </v-card>
        <v-spacer></v-spacer>
        <v-card class="text-center mb-10">
            <v-btn dark rounded class="text-center" color="green darken-1" @click="generarSalida">GRABAR PREEMBARQUE</v-btn>
        </v-card>
    </div>
</template>
<script>
import { mapState,mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import moment from 'moment'
import {required, minLength, email, sameAs} from 'vuelidate/lib/validators'
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        fecha: '',
        nombre: '',
        observaciones: '',
        lote: '',
        lotes: [],
        jumbos: [],
        fecha_jumbos: [],
        jumbos_preembarque: [],
        checkbox_select: false,
        alert: false,
        validar:false,
        bodega_origen: 1,
        clientes: [],
        cliente: '',
        bodegas: [],
        datos_adicionales: [],
        maxisacos_obtenidos: []
    }),
    mounted(){
        this.fecha = this.moment().format('YYYY-MM-DD HH:mm');
        this.cargarBodegas();
        this.cargarClientes();
        this.cargarLotes();
    },
    validations:{
        nombre: { required, minLength: minLength(6) },
        cliente: { required },
        fecha: { required },
        bodega_origen: { required },
        lotesSalientes: { required },
        /* email: { required, email },
        confirm_pwd: { required, sameAsPwd: sameAs("pwd") }, */
    },
    methods:{
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Preembarques`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se registran los preembarques, para dejar así, un listado de maxisacos reservado para el cliente. `},
                        {   tipo:`label`,   texto:`- Primero se registran los datos generales: bodega de origen, un nombre identificativo para el preembarque, la fecha posible de embarque, el cliente de destino y una observación o comentario (opcional) `},
                        {   tipo:`label`,   texto:`- Al seleccionar la bodega, se cargan los maxisacos que tiene en stock esa bodega `},
                        {   tipo:`label`,   texto:`- Para ir agregando maxisacos al preembarque, seleccione el lote, luego marque los maxisacos a reservar (del listado que aparece debajo de Bodega Origen) y haga click en la flechita azul > para pasarlos a "Reservar para Preembarque"`},
                        {   tipo:`label`,   texto:`- Así va buscando lotes y sus maxisacos. Si necesita sacar un maxisaco del preembarque, desmarquelo de "Reservar para Preembarque" y haga click en la flechita <  .... Finalmente haga click en "Grabar Preembarque".`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        validates(){
            if(this.$v.$invalid){
                console.log("Invalido", this.$v)
                return false;
            }
            this.validar = false
            console.log("Válido")
            return true;
        },
        async cargarBodegas(){
            let url = `${this.base_url}bodegas`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data.filter(b => (((b.tipo_bodega == 'bodega') || (b.tipo_bodega == 'planta')) && (!b.depende_de))) ;
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar bodegas");
            });
        },
        async cargarClientes(){
            await this.axios.get(`${this.base_url}clientes`,this.headers).then((res)=>{
                this.clientes = res.data.data;
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar clientes");
            });
        },
        async cargarLotes(){
            this.mostrarLoading({titulo:'Cargando Lotes con Maxisacos disponibles...',color:'green'})

            let url = `${this.base_url}lotes/maxisacos/disponibles/${this.bodega_origen}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.lotes = res.data.data;
                this.lote = this.lotes[0];
                if(this.lote != null){
                    this.cargarJumbosLote();
                } else {
                    this.ocultarLoading();
                }
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar lotes");
            });
        },
        async cargarJumbosLote($event){
            this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'})

            let url = `${this.base_url}jumbos/maxisacos/disponibles/${this.lote.id}/${this.bodega_origen}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.fecha_jumbos = [...new Set(res.data.map(j => j.fecha_elab))];
                
                this.jumbos = res.data.filter(j=>{
                    let res = this.jumbos_preembarque.find((p)=>{
                            return p.id == j.id;
                        });
                    return res == undefined;
                });
                console.log(this.jumbos)
                this.ocultarLoading();
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar maxisacos");
            });
        },
    
        async agregar(){
            let agregar = this.jumbos.filter(j => j.switch == true);
            let restantes = this.jumbos.filter(j => j.switch != true);
            let index_lote = this.lotes.findIndex(l => l.id == this.lote.id);
            this.$set(this.lotes[index_lote], 'maxisacos', restantes);
            this.jumbos = restantes;
            this.jumbos_preembarque = this.jumbos_preembarque.concat(agregar);
            this.checkbox_select = false;
            console.log(this.jumbos_preembarque)
        },
        async quitar(){
            /**los id de los que se van a quitar */
            let ids = this.jumbos_agregados.filter(j=>j.switch == false).map(
                j => j.id
            );
            let jumbos_quitar = this.jumbos_preembarque.filter( j => {
                return ids.includes(j.id);
            });
            /**seteando en falso la seleccion */
            jumbos_quitar.forEach(j => {
                j.switch = false;
            });
            /**conservar los jumbos del lote actual */
            let jumbos_lote = jumbos_quitar.filter(j => j.lotes_id == this.lote.id);
            this.jumbos = this.jumbos.concat(jumbos_lote);
            this.jumbos_preembarque = this.jumbos_preembarque.filter(j => {
                return !ids.includes(j.id);
            });
        },
       
        setearJumbos($event){
            this.checkbox_select = false;
        },

        async generarSalida(){
            let detalles = [];
            this.validar = true

            this.lotesSalientes.forEach(ls => {
                ls.jumbos.forEach(j => {
                    detalles.push({jumbo_id: j.id});
                });
            });
            if((detalles.length == 0) || (!this.validates()) ){
                return
            }
            let data = {
                preembarque: {
                    fecha: this.fecha,
                    bodegas_id: this.bodega_origen,
                    nombre: this.nombre,
                    clientes_id: this.cliente,
                    observaciones: this.observaciones
                },
                jumbos: detalles,
            }
            let url = `${this.base_url}preembarques`;
            await this.axios.post(url, data, this.headers).then((res)=>{
                this.ocultarLoading();
                console.log(res.data);
                if(res.data.error){
                    this.mostrarLoading({titulo:res.data.error, color:'red'})
                    return;
                } 
                this.limpiar()
                this.alert = true
            }).catch((error)=>{
                this.ocultarLoading();
                console.log('error',error);
                this.mostrarLoading({titulo:error,color:'red'})
            });
        },
        
        seleccionarTodos(){
            if(this.checkbox_select){
                this.jumbos.forEach(j => {
                    j.switch = true;
                });
            }else{
                this.jumbos.forEach(j => {
                    j.switch = false;
                });
            }
        },
        seleccionarTodosLote($event,id){
            let index = this.lotesSalientes.findIndex(l=> l.id == id);
            this.jumbos_preembarque.forEach((j,index)=>{
                if(j.lotes_id == id){
                    this.$set(this.jumbos_preembarque[index],'switch',$event);
                }
            });
        },
        limpiar(){
            this.lote = '';
            this.jumbos_preembarque = [];
            this.jumbos = [];
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        lotesSalientes(){
            /**retorna el id y nombre de los lotes distintos */
            let lotes = Array.from( new Set(this.jumbos_preembarque.map(j=>j.lotes_id)))
                    .map(id => {
                        return{
                            id:id,
                            todos:true,
                            nombre_lote: this.lotes.find(l => l.id === id).nombre_lote,
                            jumbos: this.jumbos_preembarque.filter(j => j.lotes_id == id).map(
                                j => {
                                    return {
                                        id:j.id,
                                        nro_jumbo:j.nro_jumbo,
                                        lotes_id:j.lotes_id,
                                        peso:j.peso,
                                        fecha_elab:j.fecha_elab,
                                        switch:j.switch,
                                    }
                                }
                            ).sort((a,b)=>a.nro_jumbo - b.nro_jumbo)
                        }
                    });
            return lotes;
        },
        jumbos_agregados(){
            let jbs = [];
            this.lotesSalientes.forEach(l => {
                l.jumbos.forEach(j => {
                    jbs.push(j)
                });
            });
            return jbs;
        },
        kilos(){
            return this.jumbos_preembarque.reduce((suma_parcial, valor) => suma_parcial + valor.peso,0);
        },
        jumbos_ordenados(){
            return this.jumbos.sort((a, b) => a.nro_maxisaco - b.nro_maxisaco);
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda':ModalAyudas
    }
}
</script>
<style scoped>
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }
    .mx-datepicker{
        width: 100% !important;
    }
    .inputcito{
        border:1px solid #ccc;
        margin:0.5em 0.5em;
    }
    .bloque-maxis {
        background-color: #f2f2f2;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
        margin-bottom: 20px;
        padding: 30px;
    }
    .v-alert{padding: 0px !important;}
</style>